export class Attachment{
    public fileName:string;
    public fileSize:number;
    public fileType:any;
    public userId:number;
    public token:string;
    public emailItemId:number;
    public files:string[]=[];
}